// The contents of this file were copied over from `@dashboard/junk-drawer/addon/utils/sites/weebly.ts
// temporarily while we figure out better structure for addons and dependencies
// Only the content needed for the weebly-api-bridge service was copied over
// will be deleted once we move weebly-api-bridge to dashboard-utilities
import environment from '@square/environment-utils/environment';
import { baseConnectUrl } from '@square/dashboard-utilities/utils/url';
const {
  name
} = environment();
export const WEEBLY_HOST = {
  testing: 'https://weebly.test',
  development: 'https://staging.weebly.net',
  staging: 'https://staging.weebly.net',
  sandbox: 'https://www.weebly.com',
  production: 'https://www.weebly.com'
}[name];
export const WEEBLY_DOT_COM_MERCHANT_CHECK_URL = `${WEEBLY_HOST}/app/square-sync/api/merchant/`;
export const SQUAREUP_DOT_COM_MERCHANT_CHECK_URL = '/api/v1/channels/sq-connect/ecom-merchant';
export const WEEBLY_GIFTING_OPTION_SETUP_URL = `${WEEBLY_HOST}/app/square-sync/deeplink/weebly/gifting-setup`;
export const SQUARE_ONLINE_HOST = environment().isProduction || environment().isSandbox ? 'https://square.online' : 'https://staging.weebly.net';
export const GIFTING_ELIGIBLE_URL = '/v2/stargate/getGiftingEligible';
export function createGiftingEligibleUrl() {
  return baseConnectUrl(GIFTING_ELIGIBLE_URL);
}
export function createMerchantBridgeInfoUrl(merchantToken) {
  return `${WEEBLY_DOT_COM_MERCHANT_CHECK_URL}${merchantToken}/bridge-info`;
}
export function buildUrl(path, ...args) {
  let _path = path;
  const params = [...args];
  const fragments = path.match(/(:[A-Za-z])\w+/g) || [];
  for (let i = 0; i <= fragments.length; i++) {
    _path = _path.replace(fragments[i], params[i]);
  }
  return _path;
}